import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Unauthorized from "../general/Unauthorized";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import Loading from "../general/Loading";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";

function ListarEmpresas() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [permisos, setPermisos] = useState([]);
    let userdata = [];

    const [terminoBusqueda, setTerminoBusqueda] = useState('');

    const cols = [
        { name: 'Empresa', selector: row => row.primer_nombre || 'N/A', sortable: true },
        { name: 'Tipo Documento', selector: row => row.tipo_documento || 'N/A', sortable: false, maxWidth: '12%' },
        { name: 'Nit', selector: row => {
            if (row.numero_documento && row.dv) {
                return `${row.numero_documento}-${row.dv}`;
            }
            return row.numero_documento || 'N/A';
        }, sortable: false, maxWidth: '14%' },
        { name: 'Email', selector: row => row.email || 'N/A', sortable: false },
        { name: 'Teléfono', selector: row => row.telefono || 'N/A', sortable: false, maxWidth: '12%' },
        { name: 'Estado', selector: row => getEstadoBadge(row.estado), sortable: false, maxWidth: '10%' },
        { name: 'Acción', cell: row => getBotones(row), minWidth: '20%' }
    ];

    const getEstadoBadge = (estado) => {
        if (estado === 1) {
            return <span className="badge badge-success">Activo</span>;
        } else {
            return <span className="badge badge-secondary">Inactivo</span>;
        }
    };

    const getBotones = (item) => {
        const btnEditarEmpresa = permisos.includes('crearPacientes') ? 
            <Link to={'/editar-empresa?id=' + item.id} className="btn btn-primary btn-sm" style={{ 'marginRight': '8px' }}>
                <i className="far fa-edit"></i>&nbsp;Editar
            </Link> : <></>;

        return btnEditarEmpresa;
    };

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));
        setPermisos(userdata.up || []);

        // 🔒 VALIDACIÓN DE PERMISOS - Usar el mismo permiso que listar pacientes
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'crearPacientes');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('crearPacientes')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        console.log('🚀 ListarEmpresas - Iniciando carga de datos');

        // ✅ Cargar datos del cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                console.log('✅ Cliente cargado correctamente');
                if (response.status === 200) {
                    setUsername(userdata.user_name);
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('❌ Error cargando cliente:', error);
                setLoggedIn(true);
            });

        console.log('🔍 Intentando cargar empresas...');

        // ✅ Cargar empresas - Solo tipo_cliente = 1 (SIN filtro de profesional independiente)
        const parametrosFiltro = {
            uid: userdata.user_id
        };

        console.log('📤 Enviando petición a /empresas con parámetros:', parametrosFiltro);

        axios.get('/empresas', { params: parametrosFiltro })
            .then(response => {
                console.log('📥 Respuesta recibida del servidor:', response);
                if (response.status === 200) {
                    console.log('📊 Datos de empresas recibidos:', response.data);
                    setItems(response.data);
                } else {
                    console.log('⚠️ Status inesperado:', response.status);
                }
            })
            .catch(error => {
                console.error('❌ Error cargando empresas:', error);
                if (error.response) {
                    console.error('❌ Error response status:', error.response.status);
                    console.error('❌ Error response data:', error.response.data);
                }
            });
    }, []);

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));

        const parametrosBusqueda = {
            uid: userdata.user_id,
            termino: terminoBusqueda
        };

        // ✅ Búsqueda de empresas
        axios.get('/empresas', { params: parametrosBusqueda })
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.error('❌ Error en búsqueda:', error);
            });

    }, [terminoBusqueda]);

    // 🔒 PROTECCIÓN DE RUTA
    if (loggedIn && hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn && hasPermission) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="patients" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/menu-pacientes">Clientes</Link></li>
                                        <li className="breadcrumb-item" key="bc3">Listar Empresas</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Empresas</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-9" style={{ display: 'flex', alignItems: 'center' }}>
                                    {permisos.includes('crearPacientes') &&
                                        <Link to={'/crear-empresa'} className={'btn btn-success'}>
                                            <i className="fas fa-building mr-2"></i>
                                            Crear nueva empresa
                                        </Link>
                                    }
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="terminoBusqueda">Buscar empresa</label>
                                        <input 
                                            type="text" 
                                            name="terminoBusqueda" 
                                            className="form-control" 
                                            id="terminoBusqueda" 
                                            placeholder="Nombre o documento..."
                                            onChange={(e) => setTerminoBusqueda(e.target.value)} 
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12" style={{ boxShadow: '0 0 14px rgba(0,0,0,0.09)', backgroundColor: 'white' }}>
                                    <DataTable
                                        columns={cols}
                                        data={items}
                                        pagination
                                        paginationComponentOptions={{
                                            rowsPerPageText: 'Filas por página',
                                            rangeSeparatorText: 'de',
                                            selectAllRowsItem: true,
                                            selectAllRowsItemText: 'Todos',
                                        }}
                                        noDataComponent="No hay empresas registradas"
                                        id={'tabla-empresas'}
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return (
        <Loading />
    );
}

export default ListarEmpresas;